





















































































import Vue from "vue"
import Page from "../../../components/Page.vue";
import IconButton from "@/components/IconButton.vue";

import store, { MetRiportStore } from "../services/MetRiportStore";

interface Data {
    store: MetRiportStore;
    exporting: boolean;
}

interface Methods {
    createRiport(): void;
    editRiport(id: number): void;
    removeRiport(id: number): void;
    createExport(id: number): void;
    copyRiport(id: number): void;
}

interface Computed {
    columns: any;
    items: any;
}

export default Vue.extend<Data, Methods, Computed, {}>({
    components: {
        Page,
        IconButton
    },

    async beforeMount() {
        await Promise.all([
            store.loadMetRiports(),
        ]);
    },

    data() {
        return {
            store,
            exporting: false,
        };
    },

    methods: {
        createRiport(): void {
            this.$router.push('/met-riport/create');
        },
        editRiport(id: number): void {
            this.$router.push(`/met-riport/edit/${id}`);
        },
        removeRiport(id: number): void {
            store.removeMetRiport(id).then(r => this.store.metRiportHeads = this.store.metRiportHeads.filter((row) => row.id !== id));
        },
        createExport(id: number): void {
            this.$router.push(`/met-riport/${id}/export/create`);
        },
        async copyRiport(id: number) {
            this.store.loading = true;
            await store.copyMetRiport(id);
            await store.loadMetRiports();
            this.store.loading = false;
        },
    },

    computed: {
        columns: function() {
            return [
                {
                    field: "id",
                    title: " ",
                    cell: 'command',
                    width: "200px"
                },
                {
                    field: "id",
                    title: "Azonosító",
                    headerClassName: "right_text",
                    className: "right_text",
                    width: "75px"
                },
                {
                    field: "name",
                    title: "Megnevezés"
                },
                {
                    field: "beginDate",
                    title: "Kezdő dátum",
                    headerClassName: "center_text",
                    className: "center_text",
                    type: "date",
                    format: "{0: yyyy.MM.dd.}",
                    width: "150px"
                },
                {
                    field: "endDate",
                    title: "Végdátum",
                    headerClassName: "center_text",
                    className: "center_text",
                    type: "date",
                    format: "{0: yyyy.MM.dd.}",
                    width: "150px"
                },
                { width: 0 }
            ]
        },

        items() {
            return this.store.metRiportHeads;
        },
    },
})
